export const it = {
  hanab: "Hanab",
  welcome: "Benvenuto",
  newGame: "Nuova Partita",
  tagline: "Gioca ad Hanab online con gli amici!",
  subTagline: "Gioco di carte cooperativo per più giocatori, disponibile per cellulare, tablet e pc",
  createRoom: "Crea una stanza",
  joinRoom: "Unisciti ad una stanza",
  rejoinGame: "Riprendi la partita",
  whatsHanab: "Cos'è hanab?",
  invitationByPlayers: "{{playerNames}} ti sta invitando per una partita ad Hanab 🎉",
  invitationByPlayers_plural: "{{playersNames}} ti stanno invitando per una partita ad Hanab 🎉",
  invitationNoPlayers: "Sei stato invitato per una partita ad Hanab! 🎉",
  gameFull: "Tutti presenti!",
  gameNotFull: "{{count}} / {{playersCount}} giocatori presenti",
  gameNotFull_plural: "{{count}} / {{playersCount}} giocatori presenti",
  startGame: "Avvia partita",
  addAi: "+ aggiungi AI",
  lobby: "Lobby",
  choosePlayerName: "Scegli il tuo nome di gioco",
  join: "Unisciti",
  autoplay: "Autoplay",
  shareGame: "Condividi questa partita",
  copy: "Copia",
  waitForOthers: "Aspetta altri giocatori, o ",
  gameStarted: "Partita iniziata!",
  gameStarts: "La partita inizia!",
  discardPile: "scarti ({{ discardLength }})",
  preventLossContent: "Hai sbagliato · Vuoi continuare?",
  rewind: "🕑 Turni precedenti",
  backToGame: "Torna alla partita",
  theirTurn: "E' il turno di {{currentPlayerName}}!",
  go: "Vai!",
  estimatedMaxScore: "Punteggio massimo stimato per questo miscuglio: {{reachableScore}}.",
  keepPracticing: "Continua a esercitarti",
  congrats: "Ottimo lavoro!",
  hideStats: "Nascondi stats",
  showStats: "Dettagli",
  gameOver: "La partita è finita! • Il tuo punteggio è {{playedCardsLength}} 🎉",
  score: "Hanab • Punteggio: {{score}} / {{maxPossibleScore}}",
  turnsLeftDisclaimer: "· 1 turno rimasto",
  turnsLeftDisclaimer_plural: "· {{count}} turni rimasti",
  cardLeft: "{{pileLength}} sinistra",
  tokens: "gettoni",
  deck: "mazzo",
  loading: "Caricamento...",
  menu: "Menu",
  tutorial: "Tutorial",
  rules: "Regole",
  yourTurn: "Tuo turno",
  youWillStart: "Inizierai per primo",
  hide: "Nascondi",
  reveal: "Rivela",
  cardSelected: "Carta {{position}} selezionata",
  eightTokens: "8 gettoni indizio",
  cannotDiscard: "Non puoi scartare",
  noTokens: "Nessun gettone rimasto per dare indizi",
  selectVignette: "Seleziona un numero o colore da dare come indizio",
  hint: "Indizio",
  negativeHintColor: "Non hai carte {{ color }}",
  negativeHintNumber: "Non hai {{ number }}",
  positiveHintColor: "La tua carta {{ positions }} è {{ color }}",
  positiveHintNumber: "La tua carta {{ positions }} è un {{ number }}",
  positiveHintNumberSequence: "La tua carta {{ positions }} è un {{ number }} o maggiore",
  positiveHintColor_plural: "Le tue carte {{ positions }} sono {{ color }}",
  positiveHintNumber_plural: "Le tue carte {{ positions }} sono dei {{ number }}",
  positiveHintNumberSequence_plural: "Le tue carte {{ positions }} sono dei {{ number }} o maggiori",
  you: "Tu",
  hinted: "Indizi",
  played: "Giocate",
  discarded: "Scarti",
  rollback: "Annulla azione",
  rollbackDisclaimer: "Stai per annullare l'ultima azione!",
  cannotRollback: "Non puoi ancora annullare azioni",
  abort: "Termina",
  introTutorial: "Tutorial",
  introContent: "Impariamo come si gioca!",
  playedCardsTutorial: "Carte Giocate",
  playedCardsTutorialContent:
    "Qui verranno mostrate le carte giocate. \nDi squadra, raggiungete il 5 di ogni colore per vincere il gioco.",
  discardTutorial: "Scarti",
  discardTutorialContent:
    "Qui vedrai le carte che tu\n o la tua squadra avete scartato.\nEvita di scartare quelle che\nvi servono per vincere la\npartita.",
  yourGameTutorial: "La tua mano",
  yourGameTutorialContent:
    "Queste sono le tue carte.\n Tu non puoi vederle, ma sono visibili \nagli altri giocatori e riceverai indizi su di esse.",
  teammatesTutorial: "Compagni di squadra",
  teammatesTutorialContent:
    "Questi sono i tuoi compagni di squadra.\nCome te, non possono vedere le proprie carte.\nDa loro indizi per aiutarli a giocare o scartare carte.",
  hintTokensTutorial: "Gettoni Indizi",
  hintTokensTutorialContent:
    "Alcune azioni hanno un costo.\n\n- Dare un indizio costa 1 gettone blu.\n- Scartare una carta conferisce un gettone blu.\n- Giocare un 5 conferisce un gettone blu come bonus.",
  strikeTokensTutorial: "Gettoni Strike",
  strikeTokensTutorialContent:
    "Se giocate una carta sbagliata, essa verrà scartata\n e sarà aggiunto un gettone strike.\nRaggiungere 3 gettoni strike risulta in una sconfitta immediata.",
  yourTurnTutorial: "Durante il tuo turno",
  yourTurnTutorialContent:
    "Hai 3 opzioni:\n\n- Tocca una carta della tua mano per giocarla...\n- ... o scartarla\n- Tocca le carte di un compagno di squadra per dargli un indizio.",
  skip: "✕ Salta",
  offline: "Sei offline !",
  apologies: "Ci dispiace, qualcosa è andato storto 😕",
  errorWillInvestigate:
    "Investigheremo il prima possibile. Non esitate a <1>contattarci</1> per farci sapere cosa è successo.",
  earlyDevelopment: "Il gioco è ancora in sviluppo e ci farebbe piacere avere la tua opinione.",
  publicRepo: "Abbiamo anche un <1>respository pubblico di Github</1>se vuoi contribuire o segnalare un bug.",
  backMenu: "Torna al menu",
  landingImageAlt: "Hanab gioco di carte online logo",
  classicVariant: "Classica",
  orangeVariant: "Arancione",
  multicolorVariant: "Multicolore",
  rainbowVariant: "Arcobaleno",
  criticalRainbowVariant: "Arcobaleno Critico",
  sequenceVariant: "Sequenza",
  classicVariantDescription: "Una partita classica di Hanab con 5 colori",
  multicolorVariantDescription: "Viene aggiunto un sesto seme con una sola carta per numero",
  rainbowVariantDescription: "Viene aggiunto un sesto seme che corrisponde a tutti i colori",
  criticalRainbowVariantDescription: "Rainbow, ma il 6° seme ha solo una carta di ogni",
  orangeVariantDescription: "Viene aggiunto un sesto seme classico",
  sequenceVariantDescription: "Gli indizi numerici evidenziano anche carte di valore maggiore",
  showDirectHints: "Mostra inidizi diretti",
  hideDirectHints: "Non mostrare indizi",
  botSpeed: "Velocità bot",
  normalGameExplanation: "Potrai giocare online condividendo il link della partita con i tuoi amici.",
  passandplayExplanation:
    "In questa modalità passa-e-gioca, puoi giocare offline con più giocatori che sono fisicamente nella stessa stanza, passando il dispositivo ad ogni giocatore nel loro turno",
  private: "Privato",
  hints: "Indizi",
  allowRollback: "Permetti rollback",
  preventLoss: "Previeni sconfitta",
  passandplay: "Passa & Gioca",
  passandplaySubtext: "Passa fisicamente il dispositivo ad ogni giocatore nel loro turno",
  privateSubtext: "La tua partita non sarà visibile nella sezione 'Unisciti ad una stanza'",
  advancedOptions: "Opzioni avanzate",
  players: "Giocatori",
  mode: "Modalità",
  seed: "Sedia",
  objective: "Obbiettivo",
  rulesIntro:
    "Hanab è un gioco di carte creato da Antoine Bauza. E' un gioco cooperativo, il che significa che i giocatori non sono l'uno contro l'altro ma giocano insieme per un'obbiettivo comune. Essi impersonano fuochi d'artificio sbadati che, per disattenzione, hanno mischiato le loro polveri, stoppini e razzi prima di una grande dimostrazione pirotecnica. Lo spettacolo inizierà a momenti e la situazione è piuttosto caotica. Dovranno aiutarsi a vicenda per evitare che lo spettacolo diventi un disastro!",
  rulesGoal:
    "L'obbiettivo della squadra pirotecnica è di costruire 5 fuochi d'artificio, uno di ogni colore (bianco, rosso, blu, giallo, verde) combinando carte con valore crescente (1,2,3,4,5) dello stesso colore.",
  rulesSetupTitle: "Preparazione",
  rulesSetup:
    "L'app prepara tutto al posto tuo, comodo eh?!😉. All'inizio di una partita, avrete 8 gettoni blu - i vostri indizi - e 3 gettoni rossi - i vostri gettoni strike.\n\n Il mazzo è composto da 50 carte, 10 di ogni colore <1>con numeri 1, 1, 1, 2, 2, 3, 3, 4, 4, 5</1>.\n· In una partita a 2 o 3 giocatori, verrano servite 5 carte a testa\n· In una partita a 4 o 5 giocatori, verrano servite 4 carte a testa.\n\n Come scoprirete, ai giocatori non è permesso vedere le proprie carte!",
  rulesGameTitle: "Come giocare",
  rulesGame:
    "Ogni giocatore, nel proprio turno, può eseguire una (ed una sola) delle seguenti 3 azioni. Non è permesso passare il turno.\n\n1. Dare indizi ad un altro giocatore.\n2. Scartare una carta.\n3. Giocare una carta.\n\n Non è permesso dare indizi o suggerimenti durante il turno di altri giocatori!",
  rulesHintTitle: "1. Dare Indizi",
  rulesHint:
    "Quando dai indizi, viene rimosso un gettone blu. Nota: Se non avete più gettoni blu a disposizione, non puoi decidere di dare indizi e dovrai scegliere un'altra azione.\n\nPer dare informazioni ad un altro giocatore, riguardo alle carte della sua mano, dovrai cliccare su di esse. Puoi comunicare al giocatore un colore (uno soltanto) o un valore numerico (uno soltanto)",
  rulesDiscardTitle: "2. Scarta una carta",
  rulesDiscard:
    "Scartare una carta fa riguadagnare un gettone blu. Puoi scartare una carta dalla tua mano, cliccandovi sopra. Pescherai poi una nuova carta dal mazzo e verrà aggiunta automaticamente alla tua mano. \nNota: Se avete tutti gli 8 gettoni blu a disposizione, non ti sarà permesso scartare e dovrai scegliere un'altra azione. \n Puoi consultare gli scarti in qualsiasi momento.",
  rulesPlayTitle: "3. Gioca una carta",
  rulesPlay:
    "Nel tuo turno, per giocare una carta, selezionala dalla tua mano e giocala.\nPossono succedere due cose:\n· Se la carta appartiene ad un fuoco d'artificio o vi si può aggiungere, verrà inserita nella pila corrispondente\n· Se la carta non può aggiungersi ad un fuoco d'artificio, verrà scartata e verrà aggiunto un gettone rosso degli strike\nPescheari poi una nuova carta dal mazzo\n\nQuando un giocatore completa un fuoco d'artificio giocando una carta 5 su di esso, viene riguadagnato un gettone blu come bonus. Se tutti i gettoni blu sono ancora disponibili, non guadagna nessun bonus.",
  rulesEndTitle: "Fine partita",
  rulesEnd:
    "Hanab può terminare in tre modi:\n· Se ottenete il terzo gettone rosso, avete perso la partita ed il palco va in fiamme!\n· Se la squadra completa tutti e cinque i colori di fuochi d'artificio, la squadra fa un grandioso spettacolo ed ottiene il punteggio massimo di 25 punti - 30 se in modalità multicolore!\n· Se un giocatore pesca l'ultima carta del mazzo, la partita è quasi terminata. Ogni giocatore esegue un ultimo turno, compreso il giocatore che ha pescato l'ultima carta. I giocare non possono pescare carte durante questi turni finali.\n\n I giocatori poi ottengono un punteggio in base ai fuochi d'artificio assemblati.",
  rulesExtensionTitle: "Estensioni",
  rulesExtensionMulticolor:
    "🎨 La variante multicolore aggiunge una sesta pila e un sesto set di carte con una sola carta per numero: 1, 2 ,3, 4, 5. Questi fuochi d'artificio sono dunque ridotti in quantità e dovrete essere più attenti a non scartarli. Le regole sono le stesse e dovrete completare tutte e sei le pile per ottenere il punteggio massimo di 30 punti.",
  rulesExtensionRainbow:
    "🌈 L'estensione arcobaleno aggiunge una sesta pila con la stessa quantità delle altre 5 (tre 1, due carte 2/3/4, e un 5). La particolarità è che le carte arcobaleno corrispondono a qualsiasi colore. Ogni voltà che date un indizio colore, esse vengono toccate.",
  rulesUsTitle: "Chi siamo?",
  rulesUs:
    "Siamo un gruppo di dipendenti da giochi da tavolo. Bloccati durante il lock-down del 2020, stavamo cercando un modo alternativo di giocare insieme per via remota.\nPoichè ci piace sia programmare che giocare ad Hanab, abbiamo deciso di creare una versione online del gioco compatibile con cellulari/tablet.\n\n👉 Se anche a voi piace questo gioco, compratene la <2>versione fisica</2> così da supportare il suo creatore!",
  rulesContact: "✉️ <1>Contattaci</1> se hai qualche domanda o suggerimento",
  rulesContributeRepo: "💻 Abbiamo anche un <1>respository pubblico di Github</1> nel caso ti piacerebbe contribuire.",
  rulesDiscordServer:
    "🗣 Unisciti al nostro server di Discord per discutere di potenziali nuove funzionalità o miglioramenti",
  rulesBuymeacoffee:
    "🙇‍♀️ Puoi anche supportare la nostra iniziativa e aiutarci con i costi del server offrendoci un caffè",
  noRoom: "Nessuna stanza disponibile",
  faster: "Molto veloce",
  fast: "Veloce",
  slow: "Lento",
  discard: "Scarta",
  play: "Gioca",
  green: "verde",
  red: "rossa",
  yellow: "gialla",
  blue: "blu",
  white: "bianca",
  multicolor: "multicolore",
  orange: "arancione",
  green_plural: "verdi",
  red_plural: "rosse",
  yellow_plural: "gialle",
  blue_plural: "blu",
  white_plural: "bianche",
  multicolor_plural: "multicolore",
  orange_plural: "arancioni",
  summary: "Sommario",
  summarySubtitle: "Il nostro gioco Hanab",
  gameCompleted: "Partita completata in {{ gameDuration }}",
  result: "Il nostro risultato",
  evolution: "Evoluzione",
  evolutionSubtext:
    "Segui la cronologia della partita!\nVengono mostrate le carte di ogni giocare: se sono giocabili, scartabili o critiche (una carta che abbasserà il punteggio finale se viene scartata, ad esempio una multicolore o un 5).",
  playerActions: "Azioni medie per giocatore",
  playHints: "Giocate medie per indizio: <1>{{playsPerHint}}</1>",
  playerHints: "Chi ha dato più indizi?",
  tryOutTitle: "Provalo!",
  tryOutButton: "Prova questo miscuglio",
  tryOutAlternative: "Puoi giocare anche con altre configurazioni e provare la nostra AI su <1>hanab.cards</1>",
  back: "Indietro",
  statsPlayable: "giocabile",
  statsDiscardable: "scartabile",
  statsDangerous: "critica",
  statsTurnCard: "in quel turno, la carta era",
  statsTurnAction: "Azione del giocatore in quel turno",
  showInsights: "Mostra dettagli",
  showCards: "Mostra carte",
  started: "iniziata",
  youGaveHintTurn: "Hai informato <1></1> su <3></3>",
  youDiscardedTurn: "Hai scartato <1></1>",
  youPlayedTurn: "Hai giocato <1></1>",
  somebodyHintedYouTurn: "<0></0> ti ha informato su <2></2>",
  somebodyHintedSomebodyTurn: "<0></0> ha informato <2></2> su <4></4>",
  somebodyDiscardedTurn: "<0></0> ha scartato <2></2>",
  somebodyPlayedTurn: "<0></0> ha giocato <2></2>",
  whatYouDrewTurn: "e ha pescato <1></1>",
  whatTheyDrewTurn: "e ha pescato <1></1>",
  selectLanguage: "Seleziona una lingua",
  creatingGame: "Creazione partita...",
  partySetup: "Giocatori: {{players}} · Modalità: {{variant}} · Miscuglio #{{shuffle}}",
  sendMessagePlaceholder: "Invia un messaggio ai tuoi compagni di squadra",
  sendMessage: "Invia",
  message: "<0></0>: <1></1>",
  colorBlindMode: "Modo daltonico",
  colorBlindModeSubtext: "Mostra i simboli sopra le carte per aiutare a distinguere i colori",
  pageNotFound: "Pagina non trovata",
  contributeLanguage: "Contribuisci!",
  buymeacoffeePostGame: "Supporta il gioco, <2>offrici un caffè</2>",
  next: "Avanti",
  new: "Nuovo",
  learnHanab: "Imparare",
  learnHanabTime: "~5 mn",
  learnHanabEnglish: "Questa sezione è in fase di sviluppo e non è ancora stata tradotta in tutte le lingue.",
  learnWhileWaiting: "Imparare le basi di Hanab in attesa",
};
